<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-form-group
          v-if="from_cooperation_type_id == 8"
          :label="$lang.from_relation_person_code"
          label-for="azmoon_execute"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.researcher"
            :rules="$v.from_relation_person_code_selected.$params"
          />
          <selectFind
            :allowEmpty="true"
            :options="from_relation_person_code_options"
            v-model="$v.from_relation_person_code_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.from_relation_person_code_selected.$dirty
                ? !$v.from_relation_person_code_selected.$error
                : null
            "
            :loading="from_relation_person_code_Loading"
            @input="changeState"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.from_relation_person_code_selected.$error
                ? 'block'
                : 'none',
            }"
            id="from_relation_person_code_selected_feedback"
          >
            {{
              $lang.error_required
                | replace($lang.from_relation_person_code_selected)
            }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          v-if="from_cooperation_type_id == 7"
          :label="$lang.from_relation_person_code"
          label-for="azmoon_execute"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.research_manager"
            :rules="$v.from_relation_person_code_selected.$params"
          />
          <selectFind
            :allowEmpty="true"
            :options="from_relation_person_code_options"
            v-model="$v.from_relation_person_code_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.from_relation_person_code_selected.$dirty
                ? !$v.from_relation_person_code_selected.$error
                : null
            "
            :loading="from_relation_person_code_Loading"
            @input="changeState"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.from_relation_person_code_selected.$error
                ? 'block'
                : 'none',
            }"
            id="from_relation_person_code_selected_feedback"
          >
            {{
              $lang.error_required
                | replace($lang.from_relation_person_code_selected)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12" v-if="from_cooperation_type_id == 7">
        <b-form-group
          :label="$lang.exam_resource"
          label-for="exam_resource"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.exam_resource"
            :rules="$v.exam_resource_selected.$params"
          />
          <selectFind
            :allowEmpty="true"
            :options="azmoon_execute_options"
            v-model="$v.exam_resource_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.exam_resource_selected.$dirty
                ? !$v.exam_resource_selected.$error
                : null
            "
            :loading="azmoon_execute_Loading"
            @input="changeState"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.exam_resource_selected.$error ? 'block' : 'none',
            }"
            id="exam_resource_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.exam_resource) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" v-if="from_cooperation_type_id == 7">
        <b-form-group
          :label="$lang.exam_person"
          label-for="exam_person"
          :label-cols="this.$config.form.labelCol"
        >
          <selectFind
            :allowEmpty="true"
            :options="azmoon_execute_options"
            v-model="$v.exam_person_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.exam_person_selected.$dirty
                ? !$v.exam_person_selected.$error
                : null
            "
            :loading="azmoon_execute_Loading"
            @input="changeState"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right">
        <b-button variant="success" :disabled="showBtn" @click="submit">
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="closeModal"
        >
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  validations: {
    from_relation_person_code_selected: {},
    exam_resource_selected: {},
    exam_person_selected: {},
  },
  props: {
    from_cooperation_type_id: {
      type: [String, Number],
      default: 7,
    },
    cooperation_type_id: {
      type: [String, Number],
      default: 7,
    },
  },
  data() {
    return {
      items: [],
      userRoleName: null,
      role_selected: [],
      showBtn: true,
      selected_user: null,
      exam_person_selected: null,
      azmoon_execute_Loading: false,
      azmoon_execute_options: [],
      exam_resource_selected: null,
      from_relation_person_code_Loading: false,
      from_relation_person_code_options: [],
      from_relation_person_code_selected: null,
    };
  },
  methods: {
    changeState() {
      this.showBtn = false;
    },
    submit() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      let payload = {
        from_relation_person_code:
          this.from_relation_person_code_selected &&
          this.from_relation_person_code_selected.value,
        from_cooperation_type_id: this.from_cooperation_type_id,
        to_cooperation_type_id: 3,
      };
      if (this.from_cooperation_type_id == 7) {
        payload.reference_azmoon_execute_id =
          this.exam_resource_selected && this.exam_resource_selected.value;
        payload.audience_azmoon_execute_id =
          this.exam_person_selected && this.exam_person_selected.value;
      }
      this.$emit("submit", payload);
    },

    closeModal() {
      this.$emit("closeModal");
    },

    async azmoonExecute() {
      try {
        this.azmoon_execute_Loading = true;
        let url =
          this.$config.api_url + this.$config.profile.azmoon_execute_combo;
        const response = await this.$httpService.get(url);
        let { data } = response.data;
        this.azmoon_execute_options = data.map((x) => {
          return {
            text: x.caption,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoon_execute_Loading = false;
      }
    },
    async fromRelationPersonCode() {
      try {
        this.from_relation_person_code_Loading = true;
        let params = {
          cooperation_type_id: [this.cooperation_type_id],
        };

        let response = null;
        if (this.from_cooperation_type_id == 7) {
          let url =
            this.$config.api_url + this.$config.resources.person + "/combo";
          response = await this.$httpService.get(url, params);
        } else {
          let url = this.$config.api_url + this.$config.research.researchers;
          response = await this.$httpService.get(url);
        }
        let data = response.data.data;
        if (data.length > 0) {
          this.from_relation_person_code_options =
            data &&
            data.map((x) => {
              return {
                text: x.name + ` (${x.national_code})`,
                value: x.code,
              };
            });
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.from_relation_person_code_Loading = false;
      }
    },
  },
  created() {
    this.fromRelationPersonCode();
    this.azmoonExecute();
  },
};
</script>

<style>
.f-15 {
  font-size: 15px;
}
</style>
